import cxs from 'cxs';

export const smallText: cxs.CSSObject = {
	fontSize: '12px',
	lineHeight: '16px',
	letterSpacing: '0.01em'
};

export const bodyText: cxs.CSSObject = {
	fontSize: '16px',
	lineHeight: '24px',
	letterSpacing: '-0.01em'
};

export const inputText: cxs.CSSObject = {
	fontSize: '16px',
	lineHeight: '16px'
};

export const headingText: cxs.CSSObject = {
	fontSize: '24px',
	lineHeight: '28px',
	letterSpacing: '-0.015em'
};

export const heading2Text: cxs.CSSObject = {
	fontSize: '24px',
	lineHeight: '28px',
	letterSpacing: '-0.015em'
};

export const heading3Text: cxs.CSSObject = {
	fontSize: '20px',
	lineHeight: '24px',
	letterSpacing: '-0.015em'
};

export const buttonText: cxs.CSSObject = {
	fontSize: '16px',
	lineHeight: '24px',
	letterSpacing: '-0.01em'
};

export const textSize = {
	xxl: {
		fontSize: '48px',
		lineHeight: '56px'
	},
	xl: {
		fontSize: '32px',
		lineHeight: '36px'
	},
	l: {
		fontSize: '24px',
		lineHeight: '32px'
	},
	m: {
		fontSize: '20px',
		lineHeight: '24px'
	},
	s: {
		fontSize: '16px',
		lineHeight: '24px'
	},
	xs: {
		fontSize: '14px',
		lineHeight: '20px'
	},
	xxs: {
		fontSize: '12px',
		lineHeight: '16px'
	}
};
